import { channelPartnerWebhookQueryKeys as e } from "./useChannelPartnerWebhookQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminChannelPartnerWebhooksApi as r } from "@maat/api-main";
//#region src/channelPartnerWebhooks/useRotateChannelPartnerWebhookSecretMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.rotateSecret(e.channelPartnerId, { workspaceId: e.workspaceId }),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.endpoint(n.channelPartnerId) });
		}
	});
};
//#endregion
export { i as useRotateChannelPartnerWebhookSecretMutation };
